import React, { FC, useCallback } from "react"
import { BASE_URL } from "../../constants"
import { useAppDispatch } from "../../hooks"
import { selectBooking } from "../../mugshots/mugshotsSlice"
import { Booking } from "../types"
import ChargeList from "./ChargeList"
import { formatDate } from "../../util"

interface BookingsListItemProps {
  booking: Booking
  index: number
}

const BookingsListItem: FC<BookingsListItemProps> = ({ booking, index }) => {
  const dispatch = useAppDispatch()
  const onBookingSelect = useCallback(() => {
    dispatch(selectBooking({
      booking,
      index
    }))
  }, [booking, index, dispatch])

  const bookingDate = booking.bookingDate ? formatDate(new Date(booking.bookingDate)) : "Unknown"
  const releaseDate = booking.releaseDate
    ? formatDate(new Date(booking.releaseDate))
    : (booking.homeDetention ? "Out to Home Detention" : "Still Incarcerated")

  return (
    <>
      <tr>
        <td rowSpan={2} colSpan={2} className="cellLarge" onClick={onBookingSelect}>
          <div>
            <img src={`${BASE_URL}mugshots/${booking.id}`} alt="" />
            <div className="person-info">{booking.name}</div>
          </div>
        </td>
        <td className="cellSmall">{booking.ethnicity}<br />{booking.gender}</td>
        <td className="cellSmall">{booking.age} years old</td>
        <td className="cellSmall">{bookingDate}</td>
        <td className="cellSmall">{releaseDate}</td>
        <td>{booking.bookingNumber}<br />{booking.arrestingAgency}</td>
      </tr>
      <tr>
        <td colSpan={6} className="clear-cell-border">
          <ChargeList charges={booking.charges} />
        </td>
      </tr>
    </>
  )
}

export default BookingsListItem